const CSS_DEFAULT = `
#onetrust-consent-sdk #onetrust-banner-sdk {
  background-color: rgba(255,255,255,0.85) !important;
  backdrop-filter: blur(2px) saturate(150%) !important;
  -webkit-backdrop-filter: blur(2px) saturate(150%) !important;
  box-shadow: 0 0 20px 2px rgba(0, 0, 0, .25) !important;
  overflow: hidden !important;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}
@media only screen and (max-width: 896px) {
  #onetrust-consent-sdk #onetrust-banner-sdk {
    left: 0px;
    right: 0px;
    bottom: 0px;
    width: 100%;
    pointer-events: auto;
  }
  #onetrust-policy-text {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  #onetrust-policy-text a.ot-cookie-policy-link {
    display: inline !important;
  }
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group-parent {
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-top: 0px !important;
  }
  #onetrust-button-group-parent #onetrust-button-group {
    flex-direction: row-reverse !important;
  }
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group {
  display: flex !important;
  gap: 2px !important;
  width: 100% !important;
  justify-content: space-between !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group button {
  width: auto !important;
  min-width: unset !important;
  margin: 0 !important;
  padding: 10px 16px !important;
  font-weight: 300 !important;
  font-size: 18px !important;
  line-height: 0.82rem !important;
  color: #000 !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group-parent {
  margin-bottom: 12px !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group .onetrust-banner-options {
  display: flex !important;
  gap: 10px !important;
  text-align: unset !important;
  justify-content: flex-end !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group .onetrust-banner-options button {
  flex-grow: 0;
  border-radius: 99px !important;
  background-color: var(--onetrust-branded-btn-color-bg, rgb(0, 34, 107)) !important;
  color: #FFF !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy {
  margin-top: 10px !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-close-btn-container {
  right: 6px !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text {
  font-size: 14px !important;
  line-height: 1.25rem !important;
  color: #000 !important;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group #onetrust-pc-btn-handler {
  border: none !important;
  background-color: transparent !important;
  color: #1a6cb7 !important;
  padding-left: 0px !important;
  flex-shrink: 0;
}
#onetrust-consent-sdk #onetrust-banner-sdk #onetrust-reject-all-handler, #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-accept-btn-handler {
  box-shadow: 0 1px 3px rgba(0, 0, 0, .1) !important;
  border-color: #000 !important;
}
#onetrust-banner-sdk:focus,
#onetrust-banner-sdk *:focus {
    outline: none !important;
}
/* Mobile-only rules */
@media only screen and (max-width: 896px) {
  /* Normalize button appearance - make Accept and Decline look the same */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group #onetrust-pc-btn-handler {
    background-color: var(--onetrust-branded-btn-color-bg, rgb(0, 34, 107)) !important;
    color: #FFF !important;
    border-radius: 99px !important;
    padding: 10px 16px !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .1) !important;
    border: 1px solid #000 !important;
    font-weight: 400 !important;
    transition: all 0.2s ease !important;
  }
  /* Hover states for better UX */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group button:hover {
    opacity: 0.9 !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .15) !important;
  }
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group button:active {
    transform: translateY(0) !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .1) !important;
  }
  /* Update body text color to #52667d */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text {
    color: #52667d !important;
  }
  /* Privacy policy link styling - not bold, black color, no left margin */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text a.ot-cookie-policy-link {
    font-weight: 400 !important;
    color: #000 !important;
    text-decoration: underline !important;
    transition: opacity 0.2s ease !important;
    margin-left: 0px !important;
  }
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text a.ot-cookie-policy-link:hover {
    opacity: 0.7 !important;
  }
  /* Focus states for accessibility (AA compliance) */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group button:focus {
    outline: 2px solid #4A90E2 !important;
    outline-offset: 2px !important;
    box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.3) !important;
  }
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy-text a.ot-cookie-policy-link:focus {
    outline: 2px solid #4A90E2 !important;
    outline-offset: 2px !important;
    border-radius: 2px !important;
  }
  /* Remove margin bottom from policy section */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-policy {
    margin-bottom: 0px !important;
  }
  /* Add horizontal border separator with reduced top padding */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group-parent {
    margin-top: 8px !important;
    padding-top: 8px !important;
    border-top: 1px solid rgba(82, 102, 125, 0.15) !important;
  }
  /* Ensure both buttons have equal visual weight */
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group #onetrust-accept-btn-handler,
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group #onetrust-pc-btn-handler {
    font-size: 16px !important;
    font-weight: 500 !important;
    letter-spacing: 0.3px !important;
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
  }
  #onetrust-consent-sdk #onetrust-banner-sdk #onetrust-button-group .onetrust-banner-options {
    justify-content: flex-end !important;
    content: ' ' !important;
  }
  /* Improve contrast ratios for AA compliance */
  #onetrust-consent-sdk #onetrust-banner-sdk {
    background-color: rgba(255, 255, 255, 0.95) !important;
  }
}`;

export default {
  LATINO_ONE_TRUST_CSS_MWEB: `@at-root {--onetrust-branded-btn-color-bg: rgba(31,79,45,1);}${CSS_DEFAULT}`,
  WEEE_ONE_TRUST_CSS_MWEB: `@at-root {--onetrust-branded-btn-color-bg: rgb(0,34,107);}${CSS_DEFAULT}`
};
